module.exports = __webpack_public_path__ + "img/9.b93fbc94.jpg";